"use strict";
//todo remove when ts
// @ts-ignore
import { getPrefixedDataSet } from '@elements/data-set-utils';
// @ts-ignore
import { initInScope, onFind } from "@elements/init-modules-in-scope";
// @ts-ignore
import { findIn, on, removeClass, find } from "@elements/dom-utils";
// @ts-ignore
import loadScript from '@elements/load-script';
const defaultOptions = {
    licenseKey: '7AF43751-F35F4C70-A604AE1C-12C521AE',
    download: false,
    zoom: false,
    video: false,
    plugins: [],
    consent: false,
    showConsent: true,
    consentConfig: {
        renderEvent: 'consent-overlay.render-template',
        template: '#lightboxConsentTemplate',
    }
};
const defaultSelectors = {
    base: '.js-lightbox',
    item: '.js-lightbox__item'
};
export function init(options = defaultOptions, selectors = defaultSelectors, scope = document.body) {
    onFind(selectors.base, function (baseElement) {
        createLightbox(baseElement, { ...defaultOptions, ...options }, { ...defaultSelectors, ...selectors });
    }, scope);
}
export function createLightbox(lightbox, options = defaultOptions, selectors = defaultSelectors) {
    let lightboxItems = findIn(selectors.item, lightbox);
    let elementOptions = {
        ...defaultOptions,
        ...options,
        ...getPrefixedDataSet('lightbox', lightbox)
    };
    let imports = [
        import('lightgallery')
    ];
    if (options.plugins) {
        options.plugins.map((item) => {
            imports.push(import('lightgallery/plugins/' + item + '/lg-' + item + '.umd.js'));
            if (item === 'video') {
                loadScript("https://player.vimeo.com/api/player.js");
            }
        });
    }
    let modules = [];
    imports.map((promise, index) => {
        if (index !== 0) {
            modules.push('module-' + index);
        }
    });
    Promise.all(imports).then(([lightGallery, ...modules]) => {
        elementOptions.plugins = [];
        lightGallery = lightGallery.default;
        modules.map((module) => {
            elementOptions.plugins.push(module.default);
        });
        if (elementOptions.dynamic && elementOptions.dynamicEl) {
            elementOptions.dynamicEl = JSON.parse(elementOptions.dynamicEl);
        }
        const lightboxInstance = lightGallery(lightbox, {
            ...elementOptions,
            selector: selectors.item,
            addClass: elementOptions.consent && elementOptions.showConsent ? `lg-consent-mode ${elementOptions.addClass ? elementOptions.addClass : ''}` : elementOptions.addClass,
        });
        if (elementOptions.consent && elementOptions.showConsent) {
            const savedItems = lightboxInstance.galleryItems;
            let placeholderItems = lightboxInstance.galleryItems.map((item) => {
                return { src: ' ', subHtml: `<div class="lg-sub-html__consent-alt">${savedItems[0].subHtml}</div><div class="lg-sub-html__consent js-lightbox__consent">${find(options.consentConfig.template).innerHTML}</div>` };
            });
            lightboxInstance.updateSlides(placeholderItems, 0);
            window.addEventListener(options.consentConfig.renderEvent, function () {
                elementOptions.showConsent = false;
                lightboxInstance.updateSlides(savedItems, 0);
                removeClass('lg-consent-mode', lightboxInstance.$container.selector);
            }, false);
        }
        //prevent isClickable
        const lightboxClickHandler = (evt) => {
            evt.stopImmediatePropagation();
            if (elementOptions.dynamic) {
                lightboxInstance.openGallery(0);
            }
        };
        if (lightboxItems) {
            on('click', lightboxClickHandler, lightboxItems);
        }
        if (elementOptions.consent && elementOptions.showConsent) {
            lightbox.addEventListener('lgAfterOpen', (event) => {
                if (findIn('.js-lightbox__consent', lightboxInstance.$container.selector)) {
                    initInScope(findIn('.js-lightbox__consent', lightboxInstance.$container.selector));
                }
            });
        }
    });
}
